import {Typography, Link} from '@genestack/ui';
import React from 'react';
import {OntologyTreeItem} from '../../requests/use-ontology-element-query';

interface Props {
    isInteractive: boolean;
    item: OntologyTreeItem;
    goToItem: () => void;
}

export function TreeItemLabel({isInteractive, item, goToItem}: Props) {
    if (!item.children.length) {
        return (
            <Typography title={item.name} intent="quiet" variant="section">
                {item.name}
            </Typography>
        );
    }

    if (isInteractive) {
        return (
            <Link title={item.name} onClick={goToItem} as="div">
                {item.name}
            </Link>
        );
    }

    return <Typography title={item.name}>{item.name}</Typography>;
}
